import { DBOM_POINT } from '@opm/operationLog/buriedPoint';
import {
  AllFilterPointType,
  FilterNameMapButtonId,
} from '@opm/operationLog/pages/filter';
import * as CryptoJS from 'crypto-js';

const filterKeys: Set<string | undefined> = new Set();
let id: string | undefined = undefined;

/**
 * 添加过滤器埋点
 * @param key 过滤器 key
 * @param value 过滤器值
 */
export function addFilterBuriedPoint(key?: AllFilterPointType, value?: any) {
  if (!key) return;

  // 获取过滤器显示名称（中英文）
  const filterName = getFilterDisplayName(key);
  const filterId = FilterNameMapButtonId[key];

  filterKeys.add(filterId);
  DBOM_POINT.btn(key, { filterName, id, value });
}

/**
 * 设置过滤器链接 ID（用于关联同一次操作的所有过滤器变更）
 */
export function setFilterPointLinkId() {
  const text = new Date().toString() + Math.random();
  const md5 = CryptoJS.MD5(text).toString();
  id = md5;
}

/**
 * 清除过滤器埋点状态
 */
export function clearFilterBuriedPoint() {
  setFilterPointLinkId();
  filterKeys.clear();
}

/**
 * 添加过滤器确认提交埋点
 * @param filterValue 过滤器的值
 */
export function addSubmitBuriedPoint(filterValue?: any) {
  DBOM_POINT.btn('FilterSubmit', {
    // 先去掉修改的过滤器，后续优化
    // filterList: Array.from(filterKeys).join(','), 
    id,
    filterValue,
  });
  clearFilterBuriedPoint();
}

/**
 * 添加历史过滤器埋点
 */
export function addHistoryBuriedPoint() {
  DBOM_POINT.btn('HistoryFilter');
}

/**
 * 获取过滤器显示名称
 */
function getFilterDisplayName(key: AllFilterPointType): string {
  const nameMap: Partial<Record<AllFilterPointType, string>> = {
    SingleDateRange: 'Date Range',
    MultiDateRange: 'Date Range',
    TimeRange: 'Time Range',
    CountryRegion: 'Country/Region',
    Channel: 'Channel',
    Language: 'Language',
    VideoCategory: 'Category',
    HashtagCategory: 'Category',
    MemeType: 'Meme Type',
    MemeElement: 'Meme Element',
    MemeChannel: 'Meme Channel',
    MemeRegion: 'Meme Region',
    TopNewVideoViews: 'Top 500 New Video Views',
    TopNewVideoLikes: 'Top 500 New Video Likes',
    ADGame: 'Games',
    ADType: 'Type',
    ADPlatform: 'Platform',
    ADImpressions: 'Impressions',
    ADActiveDays: 'Active Days',
    ADChannel: 'Channel',
    ADFirstSeenDateSelect: 'First Seen',
    ADLastSeenDateSelect: 'Last Seen',
    ADCountryRegion: 'Country/Region',
    FilterSubmit: 'Filter Submit',
    HistoryFilter: 'History Filter',
  };

  return nameMap[key] || key;
}
